import { useContext } from "react";

import { AuthenticationProvider } from "./authentication-component.context.lib";
import { AuthenticationContext } from "./authentication.context.lib";

const useAuthentication = () => useContext(AuthenticationContext);

export default AuthenticationProvider;
export { useAuthentication };
